import * as actions from './actions'
import mutations from './mutations'

const state = () => ({
   items: [],
   paginaAtual: null,
   totalDePaginas: null,
   registrosPorPagina: null,
   totalDeRegistros: null,
   possuiPaginaAnterior: null,
   possuiProximaPagina: null,
   codigo: null,
   sucesso: null,
   mensagens: [],
   loadingRelatorios: true
})

const usuDelegacaoHist = {
   namespaced: true,
   state,
   actions,
   mutations
}

export default {
   usuDelegacaoHist
}
